import { useState, useEffect } from "react";

import ScrollTop from "../features/ScrollTop";

const DUMMY_AUTH_URL =
  "https://run.mocky.io/v3/5185415ba171ea3a00704eed?mocky-delay=3s";

const MainForAgent = () => {
  const [form, setForm] = useState({ username: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showBanner, setShowBanner] = useState(true);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const artTimer = Math.floor(Math.random() * (5000 - 1000 + 1)) + 1000;

    try {
      await fetch(DUMMY_AUTH_URL, {
        method: "POST",
        body: JSON.stringify(form),
      });
      setTimeout(() => {
        setError("Incorrect User ID or Login Pin");
      }, artTimer);
    } catch {
      setTimeout(() => {
        setError("Incorrect User ID or Login Pin.");
      }, artTimer);
    } finally {
      setTimeout(() => {
        setForm({ username: "", password: "" });
        setLoading(false);
      }, artTimer);
    }
  };

  useEffect(() => {
    document.title = "Broker Login | AttnQ";
  }, []);

  return (
    <main className="h-fit w-full flex items-center justify-center px-4 shadow mt-14 p-6 py-14">
      <ScrollTop />
      <div className="w-full max-w-md bg-gray-100 rounded-xl shadow-md p-6 space-y-6">
        {/* 🔔 Top Notification Banner */}
        {showBanner && (
          <div className="bg-yellow-100 text-yellow-800 px-4 py-3 rounded relative text-center text-sm">
            <strong className="font-semibold">Notice:</strong> Our pilot program
            to onboard new brokers is temporarily on hold as the broker pool is
            currently full.
          </div>
        )}

        <h1 className="text-2xl text-center font-semibold pb-6">
          Broker Login
        </h1>

        {/* ❗ Error Message */}
        {error && (
          <div className="bg-red-100 text-red-700 px-4 py-2 rounded text-center text-sm">
            {error}
          </div>
        )}

        {/* 🔐 Login Form */}
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="text"
            name="username"
            placeholder="User ID"
            autoComplete="user-id"
            value={form.username}
            onChange={handleChange}
            className="w-full border rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          />

          <input
            type="password"
            name="password"
            placeholder="Login Pin"
            autoComplete="pin"
            value={form.password}
            onChange={handleChange}
            className="w-full border rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          />

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#163944] text-white font-medium py-3 rounded-lg cursor-pointer disabled:opacity-60 flex items-center justify-center"
          >
            {loading ? (
              <span className="animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full"></span>
            ) : (
              "Log In"
            )}
          </button>
        </form>
      </div>
    </main>
  );
};

export default MainForAgent;
